export const employees = [
    {
        name: "Sam",
        id: 1,
        level: "master",
        lunchBreak: {start: "12:15", end: "13:00"},
        dinnerBreak: {start: "17:15", end: "17:30"},
        workSchedules: [
            {day: 1, dayName: "Pondělí", openingHours: {
                open: null, close: null },
                isOpen: false },
            {day: 2, dayName: "Úterý", openingHours: {
                open: "10:30", close: "18:00"},
                isOpen: true },
            {day: 3, dayName: "Středa", openingHours: {
                open: "10:30", close: "18:00"},
                isOpen: true },
            {day: 4, dayName: "Čtvrtek", openingHours: {
                open: "10:30", close: "18:00"},
                isOpen: true },
            {day: 5, dayName: "Pátek", openingHours: {
                open: "10:30", close: "18:00"},
                isOpen: true },
            {day: 6, dayName: "Sobota", openingHours: {
                open: null, close: null},
                isOpen: false },
            {day: 0, dayName: "Neděle", openingHours: {
                open: null, close: null},
                isOpen: false }
        ]
    },
    {
        name: "Olena",
        id: 3,
        level: "regular",
        adminOnly: true,
        lunchBreak: {start: "13:00", end: "13:00"},
        dinnerBreak: {start: "17:30", end: "17:30"},
        workSchedules: [
            {day: 1, dayName: "Pondělí", openingHours: {
                open: null, close: null },
                isOpen: false },
            {day: 2, dayName: "Úterý", openingHours: {
                open: "10:30", close: "18:30"},
                isOpen: true },
            {day: 3, dayName: "Středa", openingHours: {
                open: "10:30", close: "18:30"},
                isOpen: true },
            {day: 4, dayName: "Čtvrtek", openingHours: {
                open: "10:30", close: "18:30"},
                isOpen: true },
            {day: 5, dayName: "Pátek", openingHours: {
                open: "10:30", close: "18:30"},
                isOpen: true },
            {day: 6, dayName: "Sobota", openingHours: {
                open: "10:30", close: "14:00"},
                isOpen: true },
            {day: 0, dayName: "Neděle", openingHours: {
                open: null, close: null},
                isOpen: false }
        ]
    },
    {
        name: "Míša",
        id: 2,
        level: "junior",
        lunchBreak: {start: "13:00", end: "13:00"},
        dinnerBreak: {start: "17:30", end: "17:30"},
        workSchedules: [
            {day: 1, dayName: "Pondělí", openingHours: {
                open: null, close: null }, isOpen: false },
            {day: 2, dayName: "Úterý", openingHours: {
                open: "13:30", close: "19:30"},
                isOpen: true },
            {day: 3, dayName: "Středa", openingHours: {
                open: "13:30", close: "19:30"},
                isOpen: true },
            {day: 4, dayName: "Čtvrtek", openingHours: {
                open: "13:30", close: "19:30"},
                isOpen: true },
            {day: 5, dayName: "Pátek", openingHours: {
                open: "13:30", close: "19:30"},
                isOpen: true },
            {day: 6, dayName: "Sobota", openingHours: {
                open: null, close: null},
                isOpen: false },
            {day: 0, dayName: "Neděle", openingHours: {
                open: null, close: null}, isOpen: false }
        ]
    }
];

export const getEmployee = (id) => employees.find((emp) => emp.id === id);

export const EMPLOYEE_ENUM = Object.freeze({
  Sam: 1,
  Olena: 3,
  Misa: 2
});

export const  getEmployeeOpeningHours = (employee, day) =>{
  return employee.workSchedules.find(d => d.day === day);
}

export const getEmployeeClosedDays = (employeeId) =>{
    let person = employees.find((emp) => emp.id === employeeId);
    return person.workSchedules.filter(d => !d.isOpen).map(d => d.day);
}

export const getServicePrice = (employeeId, service) => {
    const employee = employees.find((emp) => emp.id === employeeId);

    console.log("employeeId: ", employeeId);

    let price = service.cena[employee.level];

   return price ?? "Unknown";
};

export const getServicePriceByLevel = (level, service) => {
    let price = service.cena[level];

   return price ?? "Unknown";
};

export const getEmployeesByLevel = (level) => {
    return employees.filter(emp => emp.level === level).map(emp => emp.name).join(" / ");
}

export const getAdminOnlyEmployeeIds = () =>
    employees.filter(emp => emp.adminOnly).map(emp => emp.id);


export const barbershopOpeningHours = {
        workSchedules: [
            {day: 1, dayName: "Pondělí", openingHours: {
                    open: null, close: null },
                isOpen: false },
            {day: 2, dayName: "Úterý", openingHours: {
                    open: "10:30", close: "20:00"},
                isOpen: true },
            {day: 3, dayName: "Středa", openingHours: {
                    open: "10:30", close: "20:00"},
                isOpen: true },
            {day: 4, dayName: "Čtvrtek", openingHours: {
                    open: "10:30", close: "20:00"},
                isOpen: true },
            {day: 5, dayName: "Pátek", openingHours: {
                    open: "10:30", close: "20:00"},
                isOpen: true },
            {day: 6, dayName: "Sobota", openingHours: {
                    open: "10:30", close: "14:00"},
                isOpen: true },
            {day: 0, dayName: "Neděle", openingHours: {
                    open: null, close: null},
                isOpen: false }
        ]
}